import { createIcon, Svg } from "@gluestack-ui/icon";
import { Path } from "react-native-svg";

const AuditIcon = createIcon({
  Root: Svg,
  viewBox: "0 0 20 20",
  path: (
    <>
      <Path
        d="M11.6666 9.16797H6.66659M8.33325 12.5013H6.66659M13.3333 5.83464H6.66659M16.6666 8.7513V5.66797C16.6666 4.26784 16.6666 3.56777 16.3941 3.03299C16.1544 2.56259 15.772 2.18014 15.3016 1.94045C14.7668 1.66797 14.0667 1.66797 12.6666 1.66797H7.33325C5.93312 1.66797 5.23305 1.66797 4.69828 1.94045C4.22787 2.18014 3.84542 2.56259 3.60574 3.03299C3.33325 3.56777 3.33325 4.26784 3.33325 5.66797V14.3346C3.33325 15.7348 3.33325 16.4348 3.60574 16.9696C3.84542 17.44 4.22787 17.8225 4.69828 18.0622C5.23305 18.3346 5.93312 18.3346 7.33325 18.3346H9.58325M18.3333 18.3346L17.0833 17.0846M17.9166 15.0013C17.9166 16.6121 16.6107 17.918 14.9999 17.918C13.3891 17.918 12.0833 16.6121 12.0833 15.0013C12.0833 13.3905 13.3891 12.0846 14.9999 12.0846C16.6107 12.0846 17.9166 13.3905 17.9166 15.0013Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </>
  ),
});

AuditIcon.displayName = "AuditIcon";
export { AuditIcon };
